import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { formatTime } from '@doltech/utils/lib/date';
import { isNil } from 'lodash';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import Timer from 'react-compound-timer';
import styled from 'styled-components';

import { useTestSubmissionStore } from '../../model/test-submissions.hook';
import { TimeLimitSharedLayout } from './TimeLimitSharedLayout';

export const PracticeTestTimeLimit = observer(() => {
  const store = useTestSubmissionStore();
  const {
    currentTestSection,
    setRemainTimeInSeconds,
    inProgressTotalDurationInSeconds,
    setPracticeExtendTimeInSeconds,
    isStartedTest,
  } = store;
  const [isTimeUp, setIsTimeUp] = React.useState(false);

  const duration = React.useMemo(() => {
    if (isNil(inProgressTotalDurationInSeconds) || inProgressTotalDurationInSeconds < 0) {
      setIsTimeUp(true);
      return 0;
    }
    return inProgressTotalDurationInSeconds * 1000;
  }, [setIsTimeUp, inProgressTotalDurationInSeconds]);
  const extendedTime = React.useMemo(() => {
    if (inProgressTotalDurationInSeconds < 0) {
      return Math.abs(inProgressTotalDurationInSeconds) * 1000;
    }
    return 0;
  }, [inProgressTotalDurationInSeconds]);

  const isStartTimer = isStartedTest;
  const uuid = `${currentTestSection.id}_${isStartTimer}`;

  return (
    <TimeLimitSharedLayout
      startImmediately={isStartTimer}
      uuid={uuid}
      duration={duration}
      onTimeUp={() => {
        setIsTimeUp(true);
      }}
      onProgress={setRemainTimeInSeconds}
    >
      <TxtTime className="txt-time">
        <Timer
          key={uuid}
          startImmediately={isStartTimer}
          initialTime={duration}
          lastUnit="m"
          direction="backward"
          timeToUpdate={1000}
        >
          <Typography.Text variant="semi-bold/16" color={isTimeUp ? 'black100' : 'primary100'}>
            <Timer.Minutes formatValue={formatTime} />
            :
            <Timer.Seconds formatValue={formatTime} />
          </Typography.Text>
        </Timer>
        {isTimeUp && (
          <div className="sub-timer">
            <Timer
              key={`${uuid}${isTimeUp}`}
              direction="forward"
              initialTime={extendedTime}
              timeToUpdate={1000}
              lastUnit="m"
              startImmediately={isTimeUp && isStartTimer}
            >
              {({ getTime }) => {
                setPracticeExtendTimeInSeconds(getTime() / 1000);
                return (
                  <Typography.Text
                    className="time-countdown"
                    variant="medium/12-20"
                    color={isTimeUp ? 'primary100' : 'black100'}
                  >
                    +
                    <Timer.Minutes formatValue={formatTime} />
                    :
                    <Timer.Seconds formatValue={formatTime} />
                  </Typography.Text>
                );
              }}
            </Timer>
          </div>
        )}
      </TxtTime>
    </TimeLimitSharedLayout>
  );
});

const TxtTime = styled.div`
  text-align: center;
`;
